export function validateCpf(cpfValue: string): boolean {
  let cpfNumber = sanitizeCpf(cpfValue);

  let sum = 0;
  let remainder;

  const repeatedNumbers = /^(0{11}|1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11})$/;
  if(repeatedNumbers.test(cpfNumber))
    return false;

  for(let i = 1; i <= 9; i++)
    sum += parseInt(cpfNumber.charAt(i - 1)) * (11 - i);

  remainder = (sum * 10) % 11;
  if(remainder === 10)
    remainder = 0;

  if(remainder.toString() !== cpfNumber.charAt(9))
    return false;

  sum = 0;
  for(let i = 1; i <= 10; i++)
    sum += parseInt(cpfNumber.charAt(i - 1)) * (12 - i);

  remainder = (sum * 10) % 11;
  if(remainder === 10)
    remainder = 0;

  return remainder.toString() === cpfNumber.charAt(10);
}

export function sanitizeCpf(cpfValue: string): string {
  return cpfValue.replace(/\D/g, '');
}
